/*
 * 生命银行所用的订单操作OrderAction映射
 */
export default {
  name: 'LIFEBANK_ACTIONS',
  statuses: [
    {
      name: 'CREATE',
      description: '样本创建',
      operation: '样本创建',
      icon: ''
    },
    {
      name: 'LAB_SAMPLES_RECEIVED',
      description: '样本接收',
      operation: '样本接收',
      icon: ''
    },
    {
      name: 'LAB_DNA_READY',
      description: '核酸提取',
      operation: '核酸提取',
      icon: ''
    },
    {
      name: 'LAB_DNA_TESTED',
      description: '上机检测',
      operation: '上机检测',
      icon: ''
    },
    {
      name: 'DATA_ANALYSISED',
      description: '上机检测',
      operation: '上机检测',
      icon: ''
    },
    {
      name: 'REPORT_CREATED',
      description: '报告生成',
      operation: '报告生成',
      icon: ''
    },
    {
      name: 'REPORT_CHECKED_1ST',
      description: '报告审核',
      operation: '报告审核',
      icon: ''
    },
    {
      name: 'REPORT_CHECKED_2ND',
      description: '报告批准',
      operation: '报告批准',
      icon: ''
    },
    {
      name: 'COMPLETED',
      description: '已完成',
      operation: '完成',
      icon: ''
    }
  ]
}
